import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import { nossFilter } from '../../../../../paws/assets/frontend/js/helper/filter';

whenDocumentReady(initModule);
function initModule() {
    document.body.addEventListener('htmx:afterSettle', function(evt) {
        console.log('mp2');
        nossFilter();
    });
}